export const QuestionsUiState = {
  list: "list",
  add: "add",
  edit: "edit",
  delete: "delete",
};
